import { Group, MultiSelect, Button } from '@mantine/core';
import { X } from 'lucide-react';
import type { CoachDashboardFilters as FilterState } from './useCoachDashboardData';
import { SATISFACTION_COLORS } from './useCoachDashboardData';

interface CoachDashboardFiltersProps {
  filters: FilterState;
  onFiltersChange: (filters: Partial<FilterState>) => void;
  onReset: () => void;
  hasActiveFilters: boolean;
  coachOptions: Array<{ value: string; label: string }>;
  satisfactionOptions: string[];
  cohortOptions: Array<{ value: string; label: string }>;
}

export function CoachDashboardFilters({
  filters,
  onFiltersChange,
  onReset,
  hasActiveFilters,
  coachOptions,
  satisfactionOptions,
  cohortOptions,
}: CoachDashboardFiltersProps) {
  const satisfactionSelectData = satisfactionOptions.map(value => ({
    value,
    label: value,
  }));

  return (
    <Group gap="sm" wrap="wrap">
      <MultiSelect
        data={coachOptions}
        value={filters.coaches}
        onChange={(value) => onFiltersChange({ coaches: value })}
        placeholder="Medley Coach"
        searchable
        clearable
        w={220}
        size="sm"
        styles={{
          input: { minHeight: 36 },
        }}
      />

      <MultiSelect
        data={satisfactionSelectData}
        value={filters.overallSatisfaction}
        onChange={(value) => onFiltersChange({ overallSatisfaction: value })}
        placeholder="Overall satisfaction"
        clearable
        w={220}
        size="sm"
        renderOption={({ option }) => (
          <Group gap="xs">
            <div
              style={{
                width: 8,
                height: 8,
                borderRadius: '50%',
                backgroundColor: SATISFACTION_COLORS[option.value] || '#888',
              }}
            />
            {option.label}
          </Group>
        )}
        styles={{
          input: { minHeight: 36 },
        }}
      />

      <MultiSelect
        data={cohortOptions}
        value={filters.cohortIds}
        onChange={(value) => onFiltersChange({ cohortIds: value })}
        placeholder="Cohort"
        searchable
        clearable
        w={250}
        size="sm"
        styles={{
          input: { minHeight: 36 },
        }}
      />

      {hasActiveFilters && (
        <Button
          variant="subtle"
          color="gray"
          size="sm"
          leftSection={<X size={14} />}
          onClick={onReset}
        >
          Reset
        </Button>
      )}
    </Group>
  );
}
